import React, { useState } from "react";
import "./MainNav.css";

function MainNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [communityOpen, setCommunityOpen] = useState(false);
  const [subsidiariesOpen, setSubsidiariesOpen] = useState(false);

  return (
    <header className="main-nav">
      <div className="main-nav-container">
        {/* =====================================================
            LOGO
        ====================================================== */}

        <a href="/" className="main-nav-logo">
          <img
            src="/logo/strides extended logo.JPG"
            alt="Strides Energy & Maritime"
          />
        </a>

        {/* =====================================================
            MAIN NAVIGATION
        ====================================================== */}

        <nav className={`main-nav-menu ${menuOpen ? "menu-open" : ""}`}>
          {/* HOME */}

          <a href="/" className="main-nav-link active">
            Home
          </a>

          {/* =================================================
              ABOUT US DROPDOWN
          ================================================== */}

          <div className={`main-nav-dropdown ${aboutOpen ? "about-open" : ""}`}>
            <button
              type="button"
              className="main-nav-link about-trigger"
              onClick={() => setAboutOpen(!aboutOpen)}
            >
              About Us
            </button>

            <div className="main-nav-dropdown-menu">
              <a href="/who-we-are">Who We Are</a>

              <a href="/what-we-do">What We Do</a>

              <a href="/management">Management Team</a>

              <div
                className={`main-nav-subdropdown ${subsidiariesOpen ? "subsidiaries-open" : ""}`}
                onMouseEnter={() => setSubsidiariesOpen(true)}
                onMouseLeave={() => setSubsidiariesOpen(false)}
              >
                <button
                  type="button"
                  className="main-nav-subtrigger"
                  onClick={(event) => {
                    event.stopPropagation();
                    setSubsidiariesOpen((current) => !current);
                  }}
                  onMouseEnter={() => setSubsidiariesOpen(true)}
                  onMouseLeave={() => setSubsidiariesOpen(false)}
                >
                  Subsidiaries & Affiliates
                </button>

                <div className="main-nav-subdropdown-menu">
                  <a href="#strides-global-bermuda">Strides Global Bermuda</a>
                  <a href="#clastel-nigeria-ltd">Clastel Nigeria Ltd</a>
                  <a href="#new-revoc-ltd">New Revoc Ltd</a>
                </div>
              </div>
            </div>
          </div>

          <a href="/services" className="main-nav-link">
            Services
          </a>

          {/* PROJECTS */}

          <a href="/projects" className="main-nav-link">
            Projects
          </a>

          {/* VESSELS */}

          <a href="/vessels" className="main-nav-link">
            Vessels
          </a>

          {/* =================================================
              COMMUNITY DROPDOWN
          ================================================== */}

          <div
            className={`main-nav-dropdown ${
              communityOpen ? "community-open" : ""
            }`}
          >
            <button
              type="button"
              className="main-nav-link about-trigger"
              onClick={() => setCommunityOpen(!communityOpen)}
            >
              Community
            </button>

            <div className="main-nav-dropdown-menu">
              <a href="/community/hse">HSE & Community Impact</a>

              <a href="/community/commendations">Service & Outreach</a>
            </div>
          </div>
          {/* CAREERS */}

          <a href="/careers" className="main-nav-link">
            Careers
          </a>

          {/* CONTACT */}

          <a href="/contact" className="main-nav-link">
            Contact
          </a>
        </nav>

        {/* =====================================================
            GET IN TOUCH
        ====================================================== */}

        <a href="/contact" className="main-nav-cta">
          Get In Touch
          <span>→</span>
        </a>

        {/* =====================================================
            MOBILE MENU BUTTON
        ====================================================== */}

        <button
          type="button"
          className={`main-nav-mobile-button ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default MainNav;
